import React from "react";
import useBaggageInfoController from "./useBaggageInfo.controller.js";
import { Stack } from "@bookingcom/bui-react";
import Frame from "../../../../../Frame/index.js";
import BaggagePolicies from "../../../../../BaggagePolicies/index.js";
import IncludedBaggageList from "./BaggageInfoList.js";
import useProfiler from "../../../../../../../hooks/useProfiler.js";
import BaggageInfoMobile from "./BaggageInfo.mobile.js";
import BaggageInfoDesktop from "./BaggageInfo.desktop.js";
import { track } from "@flights/et-universal";
const useBaggageInfo = (flight) => {
    const { header, subheader, includedProducts, baggagePolicies } = useBaggageInfoController(flight);
    const { isMobile, isDesktop } = useProfiler();
    if (includedProducts) {
        return {
            header,
            subheader,
            policiesContent: ((isDesktop() && !!track("flights_funnel_new_fd_page_desktop")) ||
                (isMobile() && !!track("flights_funnel_new_fd_page_mobile"))) &&
                baggagePolicies ? (React.createElement(BaggagePolicies, { baggagePolicies: baggagePolicies })) : undefined,
            content: isDesktop() && !!track("flights_funnel_new_fd_page_desktop") ? (includedProducts ? (React.createElement(BaggageInfoDesktop, { baggageData: includedProducts, baggagePolicies: baggagePolicies, flightSegments: flight.segments })) : undefined) : isMobile() && !!track("flights_funnel_new_fd_page_mobile") ? (includedProducts ? (React.createElement(BaggageInfoMobile, { baggageData: includedProducts, baggagePolicies: baggagePolicies, flightSegments: flight.segments })) : undefined) : (React.createElement(Stack, { gap: 2 },
                includedProducts && (React.createElement(IncludedBaggageList, { flightSegments: flight.segments, includedProducts: includedProducts })),
                baggagePolicies && (React.createElement(Frame, null,
                    React.createElement(BaggagePolicies, { baggagePolicies: baggagePolicies })))))
        };
    }
    if (baggagePolicies) {
        return {
            inlinePoliciesContent: isMobile() ? React.createElement(BaggagePolicies, { baggagePolicies: baggagePolicies }) : undefined,
            content: (React.createElement(Frame, null,
                React.createElement(BaggagePolicies, { baggagePolicies: baggagePolicies })))
        };
    }
    return undefined;
};
export default useBaggageInfo;
